import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Play, Quote } from 'lucide-react';
export function VideoTestimonialSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-101">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-102">
        <div className="text-center mb-16" data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A1628] mb-4 font-playfair" data-id="element-104">
            What Our Clients Are Saying
          </h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto" data-id="element-105"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-106">
          {/* Video Embed */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.8
        }} className="relative rounded-xl overflow-hidden shadow-2xl" data-id="element-107">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-108">
              <iframe src="https://player.vimeo.com/video/1102984649?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="Boats by George - Mannix Marketing Testimonial" data-id="element-109" />
            </div>
          </motion.div>

          {/* Quote */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {
          opacity: 0,
          x: 30
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white p-8 rounded-xl border border-gray-200 shadow-lg" data-id="element-110">
            <Quote className="w-12 h-12 text-[#D4AF37] mb-6 opacity-50" data-id="element-111" />
            <blockquote className="text-xl md:text-2xl text-[#0A1628] leading-relaxed mb-8 font-playfair italic" data-id="element-112">
              "Working with Mannix helped us solve a lot of the problems that we
              set out to address. They bring a ton of expertise to the table
              when it comes to industry standards."
            </blockquote>
            <div data-id="element-113">
              <p className="text-[#0A1628] font-bold" data-id="element-114">Adam Pensel</p>
              <p className="text-[#D4AF37] text-sm" data-id="element-115">
                General Manager, Boats by George
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}